const TIME_OFF_REQUEST_STATUS_ATTRIBUTE = "illumina_timeoffrequeststatus";
const TIME_OFF_REQUEST_CANCELLED_STATUS = "Cancelled";

const timeOffRequestNotCancelledFilter = `(${TIME_OFF_REQUEST_STATUS_ATTRIBUTE} ne '${TIME_OFF_REQUEST_CANCELLED_STATUS}' or ${TIME_OFF_REQUEST_STATUS_ATTRIBUTE} eq null)`;

const isCancelledTimeOffRequest = (timeOffRequest: { illumina_timeoffrequeststatus?: string | null }): boolean => {
    return timeOffRequest.illumina_timeoffrequeststatus === TIME_OFF_REQUEST_CANCELLED_STATUS;
}

export {
    TIME_OFF_REQUEST_CANCELLED_STATUS,
    timeOffRequestNotCancelledFilter,
    isCancelledTimeOffRequest
}
